var map = {
	"./cole.jpg": 8427,
	"./cole2.jpg": 9217,
	"./details/team-01.jpg": 7520,
	"./franciscoelizalde.jpg": 7424,
	"./paco.jpg": 6587,
	"./petedowding.jpg": 1228,
	"./ronjones.jpg": 494,
	"./royray.jpg": 3550
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9434;